<template>
  <v-container>
    <material-card
      :heading="software_details.name"
      color="accent"
    >
      <v-card-text
        class="pa-4"
      >
        <v-card
          tile
          elevation="0"
        >
          <v-row class="text-center">
            <v-col sm="6" md="4" lg="3">
              <details-card
                title="Package Name"
                :body="software_details.package"
              />
            </v-col>
            <v-col sm="6" md="4" lg="3">
              <details-card
                title="Azure Package Name"
                :body="software_details.azure_package"
              />
            </v-col>
            <v-col sm="6" md="4" lg="3" v-if="type !== 'itom'">
              <details-card
                :title="correct_subtitle"
                :body="software_details.build_number"
              />
            </v-col>
            <v-col sm="6" md="4" lg="3" v-if="type !== 'itom'">
              <details-card
                title="Java Version"
                :body="details.java_version"
              />
            </v-col>
            <v-col sm="6" md="4" lg="3" v-if="type === 'ipaas'">
              <details-card
                title="REST Bridge"
                :body="software_details.rest_bridge"
              />
            </v-col>
            <v-col sm="6" md="4" lg="3" v-if="type === 'ipaas'">
              <details-card
                title="ITOM Bridge"
                :body="software_details.itom_bridge"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-card-text>
    </material-card>
  </v-container>
</template>

<script>
export default {
  name: 'SoftwareHeader',
  props: {
    details: Object,
    type: String,
  },
  data () {
    return {}
  },
  computed: {
    software_details: function () {
      if (this.type === 'assyst') {
        return {
          name: this.details.assyst_version,
          package: this.details.assyst_package_name,
          azure_package: this.details.azure_package_name,
          build_number: this.details.build_number
        }
      } else if (this.type === 'ipaas') {
        return {
          name: this.details.ipaas_version,
          package: this.details.ipaas_package_name,
          azure_package: this.details.ipaas_azure_package_name,
          build_number: this.details.ipaas_installer,
          rest_bridge: (this.details.rest_bridge_id !== null ? this.details.rest_bridge.rest_bridge_version : 'None'),
          itom_bridge: (this.details.itom_bridge_id !== null ? this.details.itom_bridge.itom_bridge_version : 'None')
        }
      } else {
        return {
          name: this.details.itom_version,
          package: this.details.itom_package_name,
          azure_package: this.details.itom_azure_package_name,
          build_number: 'N/A'
        }
      }
    },
    correct_subtitle: function () {
      return this.type === 'assyst' ? 'Build Number' : 'IPaaS Installer'
    }
  }
}
</script>